import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout-only route for /admin/settings.
// General settings content is in admin.settings.index.tsx.
// People is admin.settings.people.tsx (sibling, not child).
function OrgSettingsLayout() {
  return <Outlet />;
}

export const Route = createFileRoute("/admin/settings")({ component: OrgSettingsLayout });
